import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
import $cookies from 'vue-cookies' // 浏览存储
const qs = require('qs');
Vue.use(VueRouter)

const routes = [
  // 一级路由
  {
    path: '/',
    component: () => import('../views/Home.vue'),
    redirect: '/home',
    meta: {
      keepAlive: true, // 是否缓存界面
      isTabbarShow: true, // 判断是否Tabbar
    }
  },
  {
    path: '/home',
    name: 'home', // 首页
    component: () => import('../views/Home.vue'),
    meta: {
      keepAlive: true,
      isTabbarShow: true, // 判断是否Tabbar
    }
  },
  {
    path: '/activity', // 活动
    name: 'activity',
    component: () => import('../views/Activity.vue'),
    meta: {
      isTabbarShow: true, // 判断是否Tabbar
    }
  },
  {
    path: '/dis-hot', // 超低折扣和热门推荐
    name: 'discount_hot',
    component: () => import('../views/Discount.vue'),
    meta: {
      isTabbarShow: true, // 判断是否Tabbar
    }
  },
  {
    path: '/gift', // 礼包
    name: 'gift',
    component: () => import('../views/Gift.vue'),
    meta: {
      isTabbarShow: true, // 判断是否Tabbar
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    }
  },
  {
    path: '/mine', // 个人中心
    name: 'mine',
    component: () => import('../views/Mine.vue'),
    meta: {
      isTabbarShow: true, // 判断是否Tabbar
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
  },
  {
    path: '/login', // 登录
    name: 'login',
    component: () => import('../components/content/login-reg-retrieve/login.vue'),
    meta: {
      isTabbarShow: false, // 判断是否Tabbar
    }
  },
  {
    path: '/reg_retrieve', // 注册和找回密码
    name: 'login-reg-retrieve',
    component: () => import('../components/content/login-reg-retrieve/reg_retrieve.vue'),
    meta: {
      isTabbarShow: false, // 判断是否Tabbar
    }
  },

  // 公共二级路由
  {
    path: '/categorygame', // 游戏分类
    name: 'categoryGame',
    component: () => import('../views/categoryGame.vue')
  },
  {
    path: '/gamedetails', // 游戏详情
    name: 'gameDetails',
    component: () => import('../components/contDetailPage/gameDetails.vue')
  },
  {
    path: '/strategydetail', // 游戏攻略详情
    name: 'strategyDetail',
    component: () => import('../components/contDetailPage/strategyDetail.vue')
  },
  {
    path: '/strategylist', // 游戏攻略列表
    name: 'strategyList',
    component: () => import('../components/content/comPage/strategyList.vue')
  },
  {
    path: '/gift/giftdetails', // 礼包详情
    name: 'giftDetails',
    component: () => import('../components/contDetailPage/giftDetails.vue')
  },
  {
    path: '/activity/activitydetails', // 活动详情
    name: 'activityDetails',
    component: () => import('../components/contDetailPage/activityDetails.vue')
  },
  {
    path: '/mine/newdetails', // 帮助详情
    name: 'newDetails',
    component: () => import('../components/contDetailPage/newDetails.vue')
  },
  {
    path: '/mine/helpdetails', // 帮助详情
    name: 'helpDetails',
    component: () => import('../components/contDetailPage/helpDetails.vue')
  },

  // home相关quick-tab二级路由
  {
    path: '/home/newgame', // 新游
    name: 'newGame',
    component: () => import('../components/content/home/quick-tab/newGame.vue')
  },
  {
    path: '/home/discountgame', // 折扣
    name: 'discountGame',
    component: () => import('../components/content/home/quick-tab/discountGame.vue')
  },
  {
    path: '/home/ranking', // 排行
    name: 'ranking',
    component: () => import('../components/content/home/quick-tab/ranking.vue')
  },
  {
    path: '/home/h5game', // h5
    name: 'h5Game',
    component: () => import('../components/content/home/quick-tab/h5Game.vue')
  },
  {
    path: '/home/classify', // 分类
    name: 'classify',
    component: () => import('../components/content/home/quick-tab/classify.vue'),
    meta: {
      keepAlive: true,
    }
  },
  // home中更多
  {
    path: '/home/game', // 新游
    name: 'hotGame',
    component: () => import('../components/content/home/hotGame.vue')
  },

  // 礼包二级路由
  {
    path: '/gift/moregift', // 更多礼包
    name: 'moreGift',
    component: () => import('../components/content/gift/moreGift.vue')
  },
  {
    path: '/gift/gamegifts', // 游戏相关礼包
    name: 'gameGifts',
    component: () => import('../components/content/gift/gameGifts.vue')
  },

  // 我的二级路由
  {
    path: '/mine/setup', // 设置
    name: 'setUp',
    meta: {
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
    component: () => import('../components/content/mine/setUp.vue')
  },
  {
    path: '/mine/moregame', // 浏览更多游戏
    name: 'moreGame',
    meta: {
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
    component: () => import('../components/content/mine/moreGame.vue')
  },
  {
    path: '/mine/tool_1', // 游戏相关礼包
    name: 'tool1',
    meta: {
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
    component: () => import('../components/content/mine/tool1.vue')
  },
  {
    path: '/mine/tool_2', // 游戏相关礼包
    name: 'tool2',
    meta: {
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
    component: () => import('../components/content/mine/tool2.vue')
  },
  {
    path: '/mine/news', // 消息
    name: 'news',
    meta: {
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
    component: () => import('../components/content/mine/news.vue')
  },
  {
    path: '/mine/service', // 客服
    name: 'service',
    meta: {
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
    component: () => import('../components/content/mine/service.vue')
  },
  {
    path: '/mine/recharge', // 充值
    name: 'recharge',
    meta: {
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
    component: () => import('../components/content/mine/recharge/recharge.vue')
  },


  // 我的三级路由
  {
    path: '/mine/recharge/record', // 客服
    name: 'record',
    component: () => import('../components/content/mine/rechargeRecord.vue')
  },
  {
    path: '/mine/gift/record', // 客服
    name: 'giftRecord',
    component: () => import('../components/content/mine/giftRecord.vue')
  },
  {
    path: '/mine/recharge/playedlist', // 充值-游戏列表
    name: 'playedlist',
    meta: {
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
    component: () => import('../components/content/mine/recharge/playedlist.vue')
  },


  // 模块路由
  {
    path: '/applanding', // 落地页
    name: 'applanding',
    meta: {
      title: '叮当游',
      isTabbarShow: false, // 判断是否Tabbar
    },
    component: () => import('../independent-Module/clientlanding.vue')
  },


  /**
   * ========================================================*/
  // {
  //   path: '/ddy', // 落地页
  //   name: 'ddy',
  //   meta: {
  //     title: '叮当游'
  //   },
  //   component: () => import('../independent-Module/ddy.vue')
  // },
  // {
  //   path: '/h5/fhgc', // 落地页
  //   name: 'h5-fhgc',
  //   meta: {
  //     title: '烽火攻城'
  //   },
  //   component: () => import('../independent-Module/landingPage.vue')
  // },
  // {
  //   path: '/landing100001', // 落地页
  //   name: 'landing100001',
  //   meta: {
  //     title: '三国计'
  //   },
  //   component: () => import('../independent-Module/landingPage.vue')
  // },
  // {
  //   path: '/game', // 落地页
  //   name: 'game',
  //   meta: {
  //     title: '游戏中心'
  //   },
  //   component: () => import('../independent-Module/game.vue')
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})
router.beforeEach((to, from, next) => {
  // 百度统计
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/' + to.fullPath])
    }
  }

  // if (from.path != '/') {
  //   if (from.query.pid !== to.query.pid) {
  //     to.query.pid = from.query.pid;
  //     router.push({
  //       path: to.path,
  //       query: to.query
  //     });
  //     return
  //   }
  // }

  // 登录拦截
  if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
    $cookies.set('routePath', from.path);
    let isLogin = $cookies.get('userToken');
    if (isLogin) { // 通过cookies 获取当前的token是否存在
      // console.log('已经登录');
      next();
    } else {
      console.log('未登录');
      next({
        replace: true,
        path: '/login',
        query: {
          redirect: to.fullPath
        }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  } else {
    next();
  }

  // next();
})

export default router